export default __webpack_public_path__ + "static/media/radio-tick-white.944d474f.svg";